import styles from "./PumpSuspensionEventModal.module.scss"

import { usePolyglot } from "src/contexts"
import { useReadableTime } from "src/hooks"

interface Props {
  displayLabelKey: string;
  displayTimeString: string;
}

export function PumpSuspensionTime(props: Props) {
  const {
    displayLabelKey, displayTimeString,
  } = props
  const polyglot = usePolyglot()
  const displayTime = useReadableTime(displayTimeString)

  return (
    <>
      <div className={styles.row}>
        <span className={`${styles.textMediumRegular} ${styles.keyText}`}>
          {polyglot.t(
            displayLabelKey,
          )}
        </span>
        <span className={styles.textMediumRegular}>
          {displayTime}
        </span>
      </div>
      <div className={styles.separator} />
    </>
  )
}
